import {IntegrationMode} from './integration-mode.model';
import {Argument} from '@app/core/model/filtering/argument';
import {FilterPredicate} from '@app/core/model/filtering/filter-predicate';
import {FilterAction} from '@app/core/model/filtering/entity-filter-model';

export class ValidationRuleModel {
    arguments: Argument[] = <Argument[]>[];

    constructor(
        public filterId: string = null,
        public integrationId: string = null,
        public integrationMode: IntegrationMode = null,
        public rosterType: string = null,
        public propertyName: string = null,
        public predicateName: FilterPredicate = null,
        public friendlyName: string = null,
        public name: string = null,
        args: Argument[] = <Argument[]>[],
        public action: FilterAction = null,
        public predicateTitle: string = null,
        public predicateTitleShort: string = null,
        public applicationName: string = null,
        public applicationGuid: string = null,
        public applicationIcon: string = null,
        public isMapped: boolean = true,
        public sameRules: ValidationRuleModel[] = <ValidationRuleModel[]>[]
    ) {
        this.arguments = args;
    }
}

export class ValidationRuleApplication {
    constructor(
        public applicationName: string = null,
        public applicationGuid: string = null,
        public applicationIcon: string = null
    ) {
    }
}
